/**
 * Removed entries must not come back with an older page (chat-relay-thread D9; the admin hook's
 * guard, shared with the client's History). An older page is read before a refresh that lands
 * while it is in flight, so it may still carry an entry that refresh removed: the ids the refresh
 * removed are noted on the holder (one per room or load) and that page drops them.
 */
export interface OlderPageHolder {
  /** Ids a refresh removed while an older page was in flight; null while none is. */
  removedWhileOlder: Set<string> | null;
}

/** An older page starts: the set its answer is filtered by. */
export function startOlderPage(holder: OlderPageHolder): Set<string> {
  const removed = new Set<string>();
  holder.removedWhileOlder = removed;
  return removed;
}

/** A refresh removed these ids: an older page in flight drops them. */
export function noteRemovals(holder: OlderPageHolder, ids: Iterable<string>): void {
  const removed = holder.removedWhileOlder;
  if (!removed) return;
  for (const id of ids) removed.add(id);
}

/** The older page's entries without the ones removed while it was in flight. */
export function withoutRemoved<T extends { id: string }>(entries: readonly T[], removed: ReadonlySet<string>): T[] {
  return removed.size === 0 ? [...entries] : entries.filter((entry) => !removed.has(entry.id));
}

/** The older page finished: stop noting, unless a newer page has taken over. */
export function endOlderPage(holder: OlderPageHolder, removed: Set<string>): void {
  if (holder.removedWhileOlder === removed) holder.removedWhileOlder = null;
}
